import { render, staticRenderFns } from "./PlayerActivities.vue?vue&type=template&id=5f037756&scoped=true&"
import script from "./PlayerActivities.vue?vue&type=script&lang=js&"
export * from "./PlayerActivities.vue?vue&type=script&lang=js&"
import style0 from "./PlayerActivities.vue?vue&type=style&index=0&id=5f037756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f037756",
  null
  
)

export default component.exports